// 渠道一域名
const channelHm = ['hmtest.hzwxbz999.cn', 'hmpre.hzwxbz999.cn', 'hm.cqling.com', 'hm.yuwanf.com'];
// 渠道三域名
// const channelCw = ['hm.yxbdz14.com', 'hm.yxcgg63.com', 'hm.hnyuezan.com', 'hm.hnyuezan7.cn'];
const channelCw = [];
const TEST_WX_APP_ID = 'wxc8728ffa33aa36e0';
const PRE_WX_APP_ID = 'wx06bcc1bbddea4e75';
const PROD_WX_APP_ID = 'wxee4e6b906258b68e';
// 区分不同渠道
const getChannelType = function () {
    return 'channel_hm';
};
// 获取appId.
const getAppId = function () {
  const channelType = getChannelType();
  if (channelType === 'channel_hm') {
    if (process.env.VUE_APP_IS_TEST) return TEST_WX_APP_ID;

    switch (window.location.hostname) {
      case 'hmtest.hzwxbz999.cn':
        return TEST_WX_APP_ID;
      case 'hmpre.hzwxbz999.cn':
      case 'heipre.xxinyou.cn':
        return PRE_WX_APP_ID;
      default:
        return PROD_WX_APP_ID;
    }
  }
  if (channelType === 'channel_cw') {
    if (process.env.VUE_APP_IS_TEST || window.location.hostname == 'hm.yxbdz14.com') {
      return TEST_WX_APP_ID;
    }
    return window.location.hostname == 'hm.yxcgg63.com'
      ? PRE_WX_APP_ID
      : PROD_WX_APP_ID;
  }
};
// 获取基础api地址
const getApiBaseurl = function (type) {
  const apiType = type ? type : 'api';
  // 测试环境
  if (process.env.VUE_APP_IS_TEST) {
    return `//hmapitest.hzwxbz999.cn/${apiType}/channel_hm`;
  }
  switch (window.location.hostname) {
    // 悦玩
    case 'hmtest.hzwxbz999.cn':
    case 'heitest.xxinyou.cn':
    case 'localhost':
      return `//hmapitest.hzwxbz999.cn/${apiType}/channel_hm`;
    case 'hmpre.hzwxbz999.cn':
    case 'heipre.xxinyou.cn':
      return `//hmapipre.hzwxbz999.cn/${apiType}/channel_hm`;
    case 'hm.cqling.com':
      return `//hmapi.hzwxbz3.cn/${apiType}/channel_hm`;
    case 'hm.hzwxbz3.cn':
      return `//hmapi.hzwxbz3.cn/${apiType}/channel_hm`;
    // // 渠道三
    // case 'hm.yxbdz14.com':
    //   return `//hmapitest.hzwxbz999.cn/${apiType}/channel_cw`;
    // case 'hm.yxcgg63.com':
    //   return `//hmapipre.hzwxbz999.cn/${apiType}/channel_cw`;
    // case 'hm.hnyuezan.com':
    //   return `//hmapi.hzwxbz3.cn/${apiType}/channel_cw`;
    // case 'hm.hnyuezan7.cn':
    //   return `//hmapi.hzwxbz3.cn/${apiType}/channel_cw`;
    // 默认线上悦玩地址
    default:
      return `//hmapi.hzwxbz3.cn/${apiType}/channel_hm`;
  }
};

// 微信在线玩游戏api
const getSdkApi = function () {
  switch (window.location.hostname) {
    // 悦玩
    case 'hmtest.hzwxbz999.cn':
      return '//apirm.52ywan.com';
    case 'hmpre.hzwxbz999.cn':
      return '//h5.680game.cn';
    // // 渠道三
    // case 'hm.yxbdz14.com':
    //   return '//apirm.52ywan.com';
    // case 'hm.yxcgg63.com':
    //   return '//h5.680game.cn';
    default:
      return '//h5.hzwxbz3.cn';
  }
};
// 统一论坛平台网关，来源参考 common-tool-page 各环境 VUE_APP_API_URL
const getForumApiBaseurl = function () {
  if (process.env.VUE_APP_IS_TEST) {
    return 'https://platform-test.hzwxbz999.cn/';
  }
  switch (window.location.hostname) {
    case 'hmtest.hzwxbz999.cn':
    case 'heitest.xxinyou.cn':
    case 'localhost':
      return 'https://platform-test.hzwxbz999.cn/';
    case 'hmpre.hzwxbz999.cn':
    case 'heipre.xxinyou.cn':
      return 'https://platform-pre.hzwxbz999.cn/';
    default:
      return 'https://platform.hzwxbz2.cn';
  }
};
// cdn基础地址
export const CDN_URL = '//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform';
// 区分渠道类型
export const channelType = getChannelType();
// appId
export const appId = getAppId();
// 通用接口基础路径
export const API_URL = getApiBaseurl();
// 秒杀活动接口基础路径
export const ACT_API_URL = getApiBaseurl('act');
// 工单系统
export const SDK_API_URL = getSdkApi();
// 统一论坛接口基础路径
export const FORUM_API_URL = getForumApiBaseurl();
